export const ru = {
    appTitle: "Sport Empire",
    sidebar: {
        home: "Главная",
        teams: "Команды",
        tournaments: "Турниры",
        tournamentCategories: "Категории турниров",
        players: "Игроки",
        matches: "Матчи",
        "match-participants": "Участники матчей",
        "match-events": "События матчей",
        files: "Файлы",
        news: "Новости",
        statistics: "Статистика",
        permissions: "Разрешения",
        achievements: "Достижения",
        regions: "Регионы",
        categories: "Категории",
        sportTypes: "Виды спорта",
        playgrounds: "Площадки",
        countries: "Страны",
        cities: "Города",
        users: "Пользователи",
        sportClubs: "Спортивные секции",
        favorites: "Избранное",
        leagueAdmins: "Администраторы лиг",
        myLeague: "Моя лига",
        createLeague: "Создать высшую лигу",
        createDivision: "Создать нижнюю лигу",
        createLeagueTeam: "Создать команду",
        createLeaguePlayer: "Создать игрока"
    },
    navigation: {
        dashboard: "Панель управления",
        tournamentCategories: "Категории турниров"
    },
    nav: {
        dashboard: "Панель управления"
    },
    news: {
        title: "Новости",
        subtitle: "Управление новостными статьями и объявлениями",
        createNews: "Создать новость",
        editNews: "Редактировать новость",
        noNews: "Новости не найдены",
        createFirst: "Создайте вашу первую новость",
        newsTitle: "Заголовок",
        newsContent: "Содержание",
        newsExcerpt: "Краткое описание",
        newsSlug: "Слаг",
        newsTags: "Теги",
        newsCategory: "Категория",
        newsAuthor: "Автор",
        newsImage: "Главное изображение",
        newsStatus: "Статус",
        newsPublishDate: "Дата публикации",
        newsViews: "Просмотры",
        newsShares: "Поделились",
        newsComments: "Комментарии",
        newsLikes: "Лайки",
        searchPlaceholder: "Поиск новостей...",
        filterByStatus: "Фильтр по статусу",
        filterByCategory: "Фильтр по категории",
        filterByAuthor: "Фильтр по автору",
        filterByTags: "Фильтр по тегам",
        allStatuses: "Все статусы",
        allCategories: "Все категории",
        allAuthors: "Все авторы",
        clearFilters: "Очистить фильтры",
        showFilters: "Показать фильтры",
        hideFilters: "Скрыть фильтры",
        publishNews: "Опубликовать",
        archiveNews: "Архивировать",
        deleteNews: "Удалить",
        duplicateNews: "Дублировать",
        previewNews: "Предпросмотр",
        saveNews: "Сохранить",
        saveDraft: "Сохранить как черновик",
        publishNow: "Опубликовать сейчас",
        schedulePublish: "Запланировать публикацию",
        cancelEdit: "Отменить",
        statistics: "Статистика",
        overview: "Обзор",
        totalNews: "Всего новостей",
        publishedNews: "Опубликованных",
        draftNews: "Черновиков",
        archivedNews: "Архивированных",
        recentNews: "Последние новости",
        popularNews: "Популярные новости",
        totalViews: "Всего просмотров",
        totalShares: "Всего поделились",
        totalComments: "Всего комментариев",
        totalLikes: "Всего лайков",
        addTag: "Добавить тег",
        removeTag: "Удалить тег",
        enterTag: "Введите название тега",
        slugUnavailable: "Этот слаг уже занят",
        slugAvailable: "Этот слаг доступен",
        checkingSlug: "Проверка доступности слага...",
        generateSlug: "Сгенерировать из заголовка",
        required: "Это поле обязательно",
        titleRequired: "Заголовок обязателен",
        contentRequired: "Содержание обязательно",
        excerptRequired: "Краткое описание обязательно",
        slugRequired: "Слаг обязателен",
        categoryRequired: "Категория обязательна",
        status: {
            draft: "Черновик",
            published: "Опубликовано",
            archived: "Архивировано",
            scheduled: "Запланировано"
        },
        actions: {
            create: "Создать новость",
            edit: "Редактировать",
            delete: "Удалить",
            publish: "Опубликовать",
            archive: "Архивировать",
            duplicate: "Дублировать",
            preview: "Предпросмотр",
            save: "Сохранить",
            cancel: "Отменить"
        },
        confirmDelete: "Вы уверены, что хотите удалить эту новость?",
        confirmArchive: "Вы уверены, что хотите архивировать эту новость?",
        confirmPublish: "Вы уверены, что хотите опубликовать эту новость?",
        newsCreated: "Новость успешно создана",
        newsUpdated: "Новость успешно обновлена",
        newsDeleted: "Новость успешно удалена",
        newsPublished: "Новость успешно опубликована",
        newsArchived: "Новость успешно архивирована",
        errorCreating: "Ошибка при создании новости",
        errorUpdating: "Ошибка при обновлении новости",
        errorDeleting: "Ошибка при удалении новости",
        errorPublishing: "Ошибка при публикации новости",
        errorArchiving: "Ошибка при архивировании новости",
        errorLoading: "Ошибка при загрузке новостей",
        loadingNews: "Загрузка новостей...",
        savingNews: "Сохранение новости...",
        publishingNews: "Публикация новости...",
        archivingNews: "Архивирование новости...",
        deletingNews: "Удаление новости...",
        loadMore: "Загрузить еще",
        noMoreNews: "Больше нет новостей для загрузки",
        sortBy: "Сортировать по",
        sortByTitle: "Заголовок",
        sortByDate: "Дата",
        sortByViews: "Просмотры",
        sortByStatus: "Статус",
        sortAscending: "По возрастанию",
        sortDescending: "По убыванию",
        itemsPerPage: "Элементов на странице",
        showing: "Показано",
        of: "из",
        results: "результатов",
        page: "Страница",
        nextPage: "Следующая",
        prevPage: "Предыдущая",
        firstPage: "Первая",
        lastPage: "Последняя",
        featured: "Рекомендуемая",
        breaking: "Срочные новости",
        metaTitle: "Мета заголовок",
        metaDescription: "Мета описание"
    },
    auth: {
        loginTitle: "Вход",
        loginSubtitle: "Введите ваши данные для входа в аккаунт",
        registerTitle: "Создание Аккаунта",
        registerSubtitle: "Введите ваши данные для регистрации",
        phone: "Номер телефона",
        password: "Пароль",
        firstname: "Имя",
        lastname: "Фамилия",
        forgotPassword: "Забыли пароль?",
        loginButton: "Войти",
        registerButton: "Зарегистрироваться",
        loggingIn: "Вход...",
        creatingAccount: "Создание аккаунта...",
        noAccount: "Нет аккаунта?",
        haveAccount: "Уже есть аккаунт?",
        register: "Регистрация",
        login: "Вход",
        logout: "Выйти",
        loginAsGuest: "Просмотр как гость (только чтение)"
    },
    matches: {
        title: "Матчи",
        match: "Матч",
        matches: "Матчей",
        createMatch: "Создать матч",
        editMatch: "Редактировать матч",
        noMatches: "Матчи не найдены",
        createFirst: "Создайте ваш первый матч",
        matchId: "ID матча",
        matchDate: "Дата матча",
        startTime: "Время начала",
        endTime: "Время окончания",
        teams: "Команды",
        player: "Игрок",
        organizer: "Организатор",
        playground: "Площадка",
        reservation: "Бронирование",
        capacity: "Вместимость",
        maxCapacity: "Макс. вместимость",
        joinMatch: "Присоединиться к матчу",
        leaveMatch: "Покинуть матч",
        participants: "Участники",
        noResultsFound: "Не найдено матчей по вашему запросу",
        searchByTeam: "Поиск по названию команды...",
        allTournaments: "Все турниры",
        confirmDelete: "Удалить матч",
        deleteWarning: "Вы уверены, что хотите удалить этот матч? Это действие нельзя отменить.",
        deleteSuccess: "Матч успешно удалён",
        createSuccess: "Матч успешно создан",
        updateSuccess: "Матч успешно обновлён",
        notFound: "Матч не найден",
        tournamentInfo: "Информация о турнире",
        teamsAndScores: "Команды и счёт",
        editScore: "Редактировать счёт",
        scoreUpdated: "Счёт матча успешно обновлён",
        sort: {
            dateDesc: "Сначала новые",
            dateAsc: "Сначала старые",
            status: "По статусу"
        },
        status: {
            title: "Статус",
            allStatuses: "Все статусы",
            pending: "Предстоит",
            inProgress: "В процессе",
            completed: "Завершён",
            cancelled: "Отменён",
            in_progress: "В процессе"
        },
        statusUpdated: "Статус матча успешно обновлён",
        eventsCanOnlyBeManaged: "События можно управлять только для матчей со статусом \"В процессе\"",
        noTournament: "Нет турнира",
        unknownStatus: "Неизвестно",
        round: {
            notSpecified: "Без тура",
            missedScore: "Пропустили добавить счет"
        },
        actions: {
            startMatch: "Начать матч",
            endMatch: "Завершить матч",
            updateStatus: "Обновить статус"
        },
        form: {
            tournament: "Турнир (необязательно)",
            matchDate: "Дата и время матча",
            startTime: "Время начала",
            endTime: "Время окончания",
            roundNumber: "Номер тура / раунда (для кругового формата)",
            roundNumberPlaceholder: "Например: 1, 2, 3 или Тур 1, Раунд 1",
            city: "Город",
            selectCity: "Выберите город",
            sportType: "Вид спорта",
            selectSportType: "Выберите вид спорта",
            playground: "Площадка",
            selectPlayground: "Выберите площадку",
            maxCapacity: "Максимальная вместимость",
            description: "Описание",
            descriptionPlaceholder: "Введите описание матча...",
            teams: "Выбрать команды",
            selectTournament: "Выберите турнир",
            noTeams: "Нет доступных команд",
            success: "Матч успешно сохранён",
            errors: {
                dateRequired: "Дата матча обязательна",
                startTimeRequired: "Время начала обязательно",
                endTimeRequired: "Время окончания обязательно",
                endTimeAfterStart: "Время окончания должно быть после времени начала",
                teamsRequired: "Требуется выбрать хотя бы одну команду",
                minimumTwoTeams: "Необходимо выбрать минимум две команды",
                cityRequired: "Город обязателен",
                sportTypeRequired: "Вид спорта обязателен",
                playgroundRequired: "Площадка обязательна",
                maxCapacityRequired: "Максимальная вместимость обязательна",
                descriptionRequired: "Описание обязательно"
            }
        }
    },
    matchParticipants: {
        title: "Участники матча",
        participant: "Участник",
        createParticipant: "Добавить участника",
        editParticipant: "Редактировать участника",
        noParticipants: "Участники не найдены",
        createFirst: "Добавьте первого участника",
        playerId: "ID игрока",
        playerName: "Имя игрока",
        selectPlayer: "Выберите игрока",
        teamId: "ID команды",
        teamName: "Название команды",
        selectTeam: "Выберите команду",
        position: "Позиция",
        selectPosition: "Выберите позицию",
        status: "Статус",
        selectStatus: "Выберите статус",
        paymentStatus: "Статус оплаты",
        selectPaymentStatus: "Выберите статус оплаты",
        amount: "Сумма",
        paymentDate: "Дата оплаты",
        notes: "Примечания",
        notesPlaceholder: "Дополнительные заметки...",
        joinedAt: "Дата присоединения",
        team: "Команда",
        user: "Пользователь", 
        score: "Счёт",
        paid: "Оплачено",
        unpaid: "Не оплачено",
        processPayment: "Обработать платеж",
        matchInformation: "Информация о матче",
        matchId: "ID матча",
        participantDetails: "Детали участника",
        player: "Игрок",
        selectUser: "Выберите пользователя",
        paymentInformation: "Информация об оплате",
        hasPaid: "Оплачено",
        amountPaid: "Сумма оплаты",
        paymentMethod: "Способ оплаты",
        paymentMethodPlaceholder: "Введите способ оплаты",
        isOrganizer: "Организатор",
        confirmDelete: "Удалить участника",
        deleteWarning: "Вы уверены, что хотите удалить этого участника? Это действие нельзя отменить.",
        deleteSuccess: "Участник успешно удалён",
        createSuccess: "Участник успешно добавлен",
        updateSuccess: "Участник успешно обновлён",
        notFound: "Участник не найден",
        alreadyParticipating: "Этот игрок уже участвует в матче",
        positions: {
            goalkeeper: "Вратарь",
            defender: "Защитник",
            midfielder: "Полузащитник",
            forward: "Нападающий",
            substitute: "Запасной"
        },
        statuses: {
            pending: "Ожидание",
            confirmed: "Подтверждён", 
            cancelled: "Отменён",
            no_show: "Не явился",
            waiting_payment: "Ожидает оплаты",
            waitingPayment: "Ожидает оплаты"
        },
        paymentStatuses: {
            pending: "Ожидает оплаты",
            paid: "Оплачено",
            refunded: "Возвращено",
            cancelled: "Отменено"
        },
        form: {
            basicInfo: "Основная информация",
            paymentInfo: "Информация об оплате",
            additionalInfo: "Дополнительная информация",
            success: "Участник успешно сохранён",
            errors: {
                playerRequired: "Игрок обязателен",
                positionRequired: "Позиция обязательна",
                statusRequired: "Статус обязателен",
                paymentStatusRequired: "Статус оплаты обязателен",
                amountRequired: "Сумма обязательна",
                amountPositive: "Сумма должна быть положительной"
            }
        },
        search: {
            searchByPlayer: "Поиск по имени игрока...",
            allTeams: "Все команды",
            allPositions: "Все позиции",
            allStatuses: "Все статусы",
            allPaymentStatuses: "Все статусы оплаты"
        }
    },
    matchEvents: {
        title: "События матча",
        addEvent: "Добавить событие",
        noEvents: "Для этого матча не записано событий",
        eventType: "Тип события",
        eventTime: "Время события",
        minute: "Минута",
        minutes: "минуты",
        eventTimePlaceholder: "Введите минуту (например, 45)",
        minutePlaceholder: "Введите минуту (например, 45)",
        descriptionPlaceholder: "Дополнительное описание...",
        addEventSuccess: "Событие успешно добавлено",
        deleteEventSuccess: "Событие успешно удалено",
        deleteEventConfirm: "Вы уверены, что хотите удалить это событие?",
        eventsTitle: "События матча",
        types: {
            goal: "Гол",
            yellow_card: "Жёлтая карточка",
            red_card: "Красная карточка",
            second_yellow: "Вторая жёлтая",
            penalty_goal: "Гол с пенальти",
            missed_penalty: "Не забитый пенальти",
            own_goal: "Автогол"
        }
    },
    teams: {
        title: "Команды",
        selectPlayers: "Выбрать игроков",
        createTeam: "Создать команду",
        editTeam: "Редактировать команду",
        noTeams: "Команды не найдены",
        createFirst: "Создайте вашу первую команду",
        name: "Название команды",
        description: "Описание",
        primaryColor: "Основной цвет",
        secondaryColor: "Дополнительный цвет",
        players: "Игроки",
        noPlayers: "В этой команде нет игроков",
        confirmDelete: "Удалить команду",
        deleteWarning: "Вы уверены, что хотите удалить эту команду? Это действие нельзя отменить.",
        deleteWarningDetail: "Вы уверены, что хотите удалить команду '{name}'? Это действие нельзя отменить.",
        notFound: "Команда не найдена",
        addPlayers: "Добавить игроков",
        noPlayersSelected: "Игроки не выбраны",
        playersSelected: "игроков выбрано",
        noResultsFound: "Не найдено команд по вашему запросу",
        changeAvatar: "Сменить аватар",
        uploadAvatarHint: "Загрузите новый аватар команды (макс 5МБ)",
        city: "Город",
        enterCityId: "Введите ID города",
        sportType: "Вид спорта",
    },
    tournaments: {
        title: "Турниры",
        createTournament: "Создать турнир",
        editTournament: "Редактировать турнир",
        noTournaments: "Турниры не найдены",
        createFirst: "Создайте ваш первый турнир",
        name: "Название турнира",
        description: "Описание",
        startDate: "Дата начала",
        endDate: "Дата окончания",
        teams: "Команды",
        noTeams: "В этом турнире нет команд",
        confirmDelete: "Удалить турнир",
        deleteWarning: "Вы уверены, что хотите удалить этот турнир? Это действие нельзя отменить.",
        deleteWarningDetail: "Вы уверены, что хотите удалить турнир '{name}'? Это действие нельзя отменить.",
        notFound: "Турнир не найден",
        addTeams: "Добавить команды",
        noTeamsSelected: "Команды не выбраны",
        teamsSelected: "команд выбрано",
        maxTeamsReached: "Достигнут максимальный лимит команд",
        noResultsFound: "Не найдено турниров по вашему запросу",
        selectTeams: "Выбрать команды",
        tournamentDetails: "Детали турнира",
        basicInfo: "Информация о турнире",
        dateRange: "Период проведения",
        searchByTournament: "Поиск по названию турнира или описанию...",
        searchByName: "Поиск по названию...",
        filterByDate: "Фильтр по дате",
        registrationDeadline: "Крайний срок регистрации",
        status: "Статус",
        format: "Формат",
        hasReturnMatches: "Ответные матчи",
        roundRobin: "Круговая система",
        singleElimination: "Одиночное исключение",
        doubleElimination: "Двойное исключение",
        swiss: "Швейцарская система",
        maxTeams: "Макс. команд",
        prizePool: "Призовой фонд",
        statusUpcoming: "Предстоящий",
        statusActive: "Активный",
        statusCompleted: "Завершённый",
        statusCancelled: "Отменённый",
        formatSingleElimination: "Одиночное исключение",
        formatDoubleElimination: "Двойное исключение",
        formatRoundRobin: "Круговая система",
        formatSwiss: "Швейцарская система",
        addMoreTeams: "Добавить больше команд",
        selectStartDate: "Выберите дату начала",
        selectEndDate: "Выберите дату окончания",
        selectedTeams: "Выбранные команды",
        enterName: "Введите название турнира",
        city: "Город",
        sportType: "Вид спорта",
        category: "Категория турнира",
        numberOfMatches: "Количество матчей",
        matchesCountLabel: "матчей",
        teamPairsLabel: "пар команд",
        selectRoundToViewMatches: "Выберите тур для просмотра матчей",
        pairAssignments: "Составы пар в этом туре:",
        location: "Местоположение",
        schedule: "Расписание туров",
        generateSchedule: "Создать расписание",
        regenerateSchedule: "Пересоздать расписание",
        nameRequired: "Название турнира обязательно",
        startDateRequired: "Дата начала обязательна",
        endDateRequired: "Дата окончания обязательна",
        cityRequired: "Город обязателен",
        sportTypeRequired: "Вид спорта обязателен",
        categoryRequired: "Категория обязательна",
        minTeamsRequired: "Требуется минимум 2 команды"
    },
    common: {
        or: "или",
        save: "Сохранить",
        saving: "Сохранение...",
        cancel: "Отмена",
        delete: "Удалить",
        remove: "Удалить",
        view: "Просмотр",
        deleting: "Удаление...",
        edit: "Редактировать",
        create: "Создать",
        update: "Обновить",
        warning: "Предупреждение",
        loading: "Загрузка...",
        notSpecified: "Не указано",
        notSet: "Не задано",
        image: "Изображение",
        viewImage: "Просмотреть изображение",
        viewGif: "Просмотреть GIF",
        viewDetails: "Подробнее",
        backToList: "Вернуться к списку",
        search: "Поиск",
        actions: "Действия",
        searchByPosition: "Поиск по позиции, клубу или гражданству...",
        searchByName: "Поиск по названию команды или описанию...",
        searchByTournament: "Поиск по названию турнира или описанию...",
        select: "Выбрать",
        previous: "Назад",
        next: "Вперед",
        selectDateTime: "Выберите дату и время",
        of: "из",
        showing: "Показано",
        page: "Страница",
        players: "игроков",
        selectAll: "Выбрать все",
        deselectAll: "Снять выделение",
        filter: "Фильтр",
        filterOptions: "Опции фильтра",
        filters: "Фильтры",
        apply: "Применить",
        reset: "Сбросить",
        all: "Все",
        clearAll: "Очистить всё",
        add: "Добавить",
        min: "Мин",
        max: "Макс",
        active: "Активно",
        inactive: "Неактивно",
        back: "Назад",
        goToMatchesToManageParticipants: "Перейдите к матчам для управления участниками",
        days: {
            monday: "Понедельник",
            tuesday: "Вторник",
            wednesday: "Среда",
            thursday: "Четверг",
            friday: "Пятница",
            saturday: "Суббота",
            sunday: "Воскресенье"
        },
        status: "Статус",
        description: "Описание",
        confirmDelete: "Подтвердить удаление",
        notFound: "Не найдено",
        additionalInformation: "Дополнительная информация",
        dashboard: "Панель управления",
        selectTeam: "Выбрать команду",
        teamId: "ID команды",
        noTeamsFound: "Команды не найдены",
        loadingTeams: "Загрузка команд...",
        noDescription: "Нет описания",
        yes: "Да",
        no: "Нет",
        metadata: "Метаданные",
        updatedAt: "Обновлено",
        years: "лет",
        none: "Нет",
        close: "Закрыть",
    },
    players: {
        title: "Игроки",
        createPlayer: "Создать игрока",
        editPlayer: "Редактировать игрока",
        noPlayers: "Игроки не найдены",
        noPlayersAvailable: "Нет доступных игроков",
        createFirst: "Создайте вашего первого игрока",
        fullName: "Полное имя",
        fullNamePlaceholder: "Введите полное имя игрока",
        searchPlaceholder: "Поиск по имени, позиции или национальности",
        position: "Позиция",
        club: "Клуб",
        team: "Команда",
        selectTeam: "Выберите команду",
        age: "Возраст",
        height: "Рост",
        weight: "Вес",
        nationality: "Национальность",
        birthplace: "Место рождения",
        preferredFoot: "Рабочая нога",
        leftFoot: "Левая",
        rightFoot: "Правая",
        bothFeet: "Обе",
        bio: "Биография",
        noBio: "Биография отсутствует",
        identificationNumber: "Идентификационный номер",
        number: "Номер",
        userId: "ID пользователя",
        heroId: "ID героя",
        heroIdPlaceholder: "Введите ID героя (необязательно)",
        heroGif: "GIF героя",
        player: "Игрок",
        confirmDelete: "Удалить игрока",
        deleteWarning: "Вы уверены, что хотите удалить этого игрока? Это действие нельзя отменить.",
        deleteWarningDetail: "Вы уверены, что хотите удалить игрока с позицией '{position}'? Это действие нельзя отменить.",
        notFound: "Игрок не найден",
        playerDetails: "Детали игрока",
        basicInfo: "Информация",
        userAssignment: "Назначение пользователя",
        physicalData: "Физические данные",
        nationalityInfo: "Гражданство",
        user: "Пользователь",
        searchUser: "Поиск пользователя...",
        additionalInfo: "Доп. информация",
        biography: "Биография",
        noResults: "Не найдено игроков по вашему запросу",
        noResultsFound: "Не найдено игроков по вашему запросу",
        filter: {
            byTeam: "Фильтр по команде",
            byPosition: "Фильтр по позиции",
            byNationality: "Фильтр по национальности"
        },
        positions: {
            goalkeeper: "Вратарь",
            centerBack: "Центральный защитник",
            leftBack: "Левый защитник",
            rightBack: "Правый защитник",
            leftWingBack: "Левый фланговый защитник",
            rightWingBack: "Правый фланговый защитник",
            centralDefensiveMidfielder: "Опорный полузащитник",
            centralMidfielder: "Центральный полузащитник",
            leftMidfielder: "Левый полузащитник",
            rightMidfielder: "Правый полузащитник",
            centralAttackingMidfielder: "Атакующий полузащитник",
            leftWing: "Левый крайний",
            rightWing: "Правый крайний",
            striker: "Нападающий",
            centerForward: "Центральный нападающий"
        },
        changeAvatar: "Сменить аватар",
        uploadAvatarHint: "Загрузите новый аватар игрока (макс 5МБ)",
        unknownPlayer: "Неизвестный игрок",
    },
    sportTypes: {
        title: "Виды спорта",
        subtitle: "Управление видами спорта и их конфигурациями",
        sportType: "Вид спорта",
        createSportType: "Создать вид спорта",
        editSportType: "Редактировать вид спорта",
        noSportTypes: "Виды спорта не найдены",
        createFirst: "Создайте ваш первый вид спорта",
        name: "Название",
        namePlaceholder: "Введите название вида спорта",
        description: "Описание",
        descriptionPlaceholder: "Введите описание вида спорта",
        teamBased: "Командный",
        minTeamSize: "Минимальный размер команды",
        maxTeamSize: "Максимальный размер команды",
        teamSize: "Размер команды",
        teamConfiguration: "Конфигурация команды",
        active: "Активный",
        basicInfo: "Основная информация",
        sportTypeDetails: "Детали вида спорта",
        confirmDelete: "Удалить вид спорта",
        deleteWarning: "Вы уверены, что хотите удалить этот вид спорта? Это действие нельзя отменить.",
        deleteWarningDetail: "Вы уверены, что хотите удалить '{name}'? Это действие нельзя отменить.",
        notFound: "Вид спорта не найден",
        searchByName: "Поиск по названию...",
        selectSportType: "Выберите вид спорта",
        allSportTypes: "Все виды спорта",
        unknownSportType: "Неизвестный вид спорта",
    },
    countries: {
        title: "Страны",
        subtitle: "Управление странами и их информацией",
        pageDescription: "Просмотр и управление странами, их кодами и связанными городами",
        country: "Страна",
        createCountry: "Создать страну",
        editCountry: "Редактировать страну",
        viewCountry: "Просмотр страны",
        noCountries: "Страны не найдены",
        createFirst: "Создайте вашу первую страну",
        searchPlaceholder: "Поиск по названию или коду...",
        confirmDelete: "Вы уверены, что хотите удалить {name}?",
        fields: {
            name: "Название",
            code: "Код",
            isoCode2: "ISO Код 2",
            cities: "Города",
            active: "Активна"
        },
        placeholders: {
            name: "Введите название страны",
            code: "Введите код страны (3 буквы)",
            isoCode2: "Введите ISO код (2 буквы)"
        },
        validation: {
            nameRequired: "Название страны обязательно",
            codeRequired: "Код страны обязателен",
            codeLength: "Код страны должен состоять из 3 символов",
            isoCode2Required: "ISO Код 2 обязателен",
            isoCode2Length: "ISO Код 2 должен состоять из 2 символов"
        }
    },
    cities: {
        title: "Города",
        city: "Город",
        createCity: "Создать город",
        editCity: "Редактировать город",
        noCities: "Города не найдены",
        createFirst: "Создайте ваш первый город",
        name: "Название",
        country: "Страна",
        selectCountry: "Выберите страну",
        region: "Регион",
        population: "Население",
        latitude: "Широта",
        longitude: "Долгота",
        postalCode: "Почтовый индекс",
        location: "Местоположение",
        coordinates: "Координаты",
        coordinatesRequired: "Пожалуйста, выберите местоположение на карте",
        selectOnMap: "Выбрать на карте",
        selectCity: "Выберите город",
        allCities: "Все города",
        unknownCity: "Неизвестный город",
        cityDetails: "Детали города",
        confirmDelete: "Удалить город",
        deleteWarning: "Вы уверены, что хотите удалить этот город? Это действие нельзя отменить.",
        deleteWarningDetail: "Вы уверены, что хотите удалить '{name}'? Это действие нельзя отменить.",
        notFound: "Город не найден",
        searchByName: "Поиск по названию...",
        searchByCountry: "Поиск по стране...",
        searchByRegion: "Поиск по региону...",
        filterByCountry: "Фильтр по стране",
        filterByRegion: "Фильтр по региону",
        basicInfo: "Основная информация",
        geographicInfo: "Географическая информация",
        demographics: "Демография"
    },
    validations: {
        phoneRequired: "Необходимо указать номер телефона",
        phoneInvalid: "Номер телефона должен начинаться с '+' и содержать от 10 до 15 цифр",
        passwordRequired: "Необходимо указать пароль",
        passwordShort: "Пароль должен содержать не менее 6 символов",
        nameRequired: "Необходимо указать имя",
        nameShort: "Имя должно содержать не менее 2 символов",
        descriptionRequired: "Необходимо указать описание",
        colorRequired: "Необходимо указать цвет",
        positionRequired: "Необходимо указать позицию",
        clubRequired: "Необходимо указать клуб",
        nationalityRequired: "Необходимо указать национальность",
        birthplaceRequired: "Необходимо указать место рождения",
        ageInvalid: "Возраст должен быть больше 0",
        heightInvalid: "Рост должен быть больше 0",
        weightInvalid: "Вес должен быть больше 0",
        identificationRequired: "Необходимо указать идентификационный номер",
        startDateRequired: "Необходимо указать дату начала",
        endDateRequired: "Необходимо указать дату окончания",
        endDateAfterStart: "Дата окончания должна быть позже даты начала",
        registrationDeadlineBeforeStart: "Крайний срок регистрации должен быть до даты начала",
        minTeams: "Требуется минимум 2 команды",
        prizePoolPositive: "Призовой фонд должен быть положительным"
    },
    languages: {
        en: "Английский",
        ru: "Русский"
    },
    errors: {
        failedToLoadPlayers: "Не удалось загрузить данные игроков",
        failedToLoadTeams: "Не удалось загрузить данные команд"
    },
    statistics: {
        tournamentTable: "Турнирная таблица",
        recentMatches: "Последние матчи",
        overview: "Обзор статистики",
        noStatistics: "Статистика недоступна",
        noMatches: "Матчи не найдены",
        team: "Команда",
        played: "И",
        wins: "В",
        draws: "Н",
        losses: "П",
        goalsFor: "ЗМ",
        goalsAgainst: "ПМ",
        goalDiff: "РМ",
        points: "О",
        win: "Победа",
        loss: "Поражение",
        draw: "Ничья",
        totalMatches: "Всего матчей",
        winRate: "Процент побед",
        goalsScored: "Забито голов",
        goalsConceded: "Пропущено голов",
        loadMore: "Загрузить еще",
        // Player statistics
        playerStatistics: "Статистика игрока",
        noPlayerStats: "Статистика игрока недоступна",
        matchesPlayed: "Сыгранные матчи",
        goals: "Голы",
        assists: "Передачи",
        playerSummary: "Сводка игрока",
        goalsPerMatch: "Голов за матч",
        assistsPerMatch: "Передач за матч"
    },
    playgrounds: {
        title: "Площадки",
        playground: "Площадка",
        createPlayground: "Создать площадку",
        editPlayground: "Редактировать площадку",
        noPlaygrounds: "Площадки не найдены",
        createFirst: "Создайте вашу первую площадку",
        name: "Название",
        location: "Местоположение",
        description: "Описание",
        pricePerHour: "Цена за час",
        maxCapacity: "Максимальная вместимость",
        currentCapacity: "Текущая загрузка",
        availableFrom: "Доступна с",
        availableTo: "Доступна до",
        status: "Статус",
        active: "Активна",
        inactive: "Неактивна",
        capacity: "Вместимость",
        hours: "Часы работы",
        pricing: "Стоимость",
        workingHours: "Рабочие часы",
        currentMax: "Текущая / Макс",
        images: "Изображения",
        details: "Детали",
        reservations: "Бронирования",
        reservationHistory: "История бронирований",
        reservationPeriod: "Период бронирования",
        user: "Пользователь",
        noReservations: "Бронирования не найдены",
        confirmDelete: "Удалить площадку",
        deleteWarning: "Вы уверены, что хотите удалить площадку '{name}'? Это действие нельзя отменить.",
        notFound: "Площадка не найдена",
        searchByName: "Поиск по названию...",
        searchByLocation: "Поиск по местоположению...",
        minPrice: "Мин. цена",
        maxPrice: "Макс. цена",
        namePlaceholder: "Введите название площадки",
        locationPlaceholder: "Введите адрес местоположения",
        descriptionPlaceholder: "Введите описание площадки",
        fieldSize: "Размер поля",
        fieldSizePlaceholder: "например, 40x20 метров",
        fieldCoverType: "Тип покрытия поля",
        selectFieldCoverType: "Выберите тип покрытия",
        fieldCoverTypes: {
            outdoor: "Открытое",
            indoor: "Крытое",
            semiCovered: "Полукрытое"
        },
        fieldSurfaceType: "Тип поверхности поля",
        selectFieldSurfaceType: "Выберите тип поверхности", 
        fieldSurfaceTypes: {
            artificialGrass: "Искусственная трава",
            naturalGrass: "Натуральная трава",
            concrete: "Бетон",
            rubber: "Резина",
            sand: "Песок"
        },
        address: "Адрес",
        addressPlaceholder: "Введите адрес площадки",
        coordinatesPlaceholder: "Координаты будут установлены автоматически",
        selectOnMap: "Выбрать на карте",
        validation: {
            cityRequired: "Город обязателен",
            pricePositive: "Цена должна быть положительной",
            capacityPositive: "Максимальная вместимость должна быть положительной",
            currentCapacityValid: "Текущая загрузка должна быть корректной",
            currentCapacityNotExceedMax: "Текущая загрузка не может превышать максимальную",
            availableFromRequired: "Время начала работы обязательно",
            availableToRequired: "Время окончания работы обязательно",
            availableToAfterFrom: "Время окончания должно быть после времени начала",
            fieldSizeRequired: "Размер поля обязателен",
            fieldCoverTypeRequired: "Тип покрытия поля обязателен",
            fieldSurfaceTypeRequired: "Тип поверхности поля обязателен",
            addressRequired: "Адрес обязателен",
            coordinatesRequired: "Координаты обязательны"
        },
        changeImage: "Изменить изображение",
        uploadImageHint: "Загрузите новое изображение площадки (макс. 5МБ)",
        facilities: "Удобства"
    },
    playgroundFacilities: {
        title: "Удобства площадок",
        subtitle: "Управление удобствами, доступными на площадках",
        pageDescription: "Создание и управление удобствами площадок для лучшего сервиса",
        facility: "Удобство",
        facilities: "Удобства",
        createFacility: "Создать удобство",
        editFacility: "Редактировать удобство",
        assignFacilities: "Назначить удобства",
        removeAllFacilities: "Удалить все удобства",
        allFacilities: "Все удобства",
        assignedFacilities: "Назначенные удобства",
        availableFacilities: "Доступные удобства",
        selectedFacilities: "Выбранные удобства",
        assignSelected: "Назначить выбранные",
        noFacilities: "Удобства не найдены",
        noAssignedFacilities: "К этой площадке не назначены удобства",
        noAvailableFacilities: "Нет доступных удобств для назначения",
        name: "Название",
        description: "Описание",
        category: "Категория",
        icon: "Иконка",
        quantity: "Количество",
        notes: "Заметки",
        preview: "Предпросмотр",
        namePlaceholder: "Введите название удобства",
        descriptionPlaceholder: "Введите описание удобства",
        searchPlaceholder: "Поиск удобств...",
        notesPlaceholder: "Дополнительные заметки (необязательно)",
        selectCategory: "Выберите категорию",
        selectIcon: "Выберите иконку",
        customIconPlaceholder: "Или введите код пользовательской иконки",
        iconHint: "Выберите из готовых иконок или введите код пользовательской иконки",
        confirmDelete: "Вы уверены, что хотите удалить это удобство?",
        confirmRemoveFromPlayground: "Вы уверены, что хотите удалить это удобство с площадки?",
        confirmRemoveAll: "Вы уверены, что хотите удалить все удобства с этой площадки?",
        categories: {
            sports: "Спортивное оборудование",
            safety: "Безопасность и охрана",
            comfort: "Комфорт и удобства",
            utilities: "Коммунальные услуги",
            entertainment: "Развлечения",
            accessibility: "Доступность"
        },
        icons: {
            ball: "Мяч",
            goal: "Ворота",
            lighting: "Освещение",
            parking: "Парковка",
            restroom: "Туалет",
            water: "Фонтанчик с водой",
            bench: "Скамейка",
            security: "Камера безопасности",
            wifi: "WiFi",
            accessibility: "Доступность"
        }
    },
    achievements: {
        title: "Достижения",
        description: "Управление достижениями и наградами игроков",
        createAchievement: "Создать достижение",
        editAchievement: "Редактировать достижение",
        achievement: "Достижение", 
        player: "Игрок",
        achievementDate: "Дата достижения",
        category: "Категория",
        points: "Очки",
        featured: "Рекомендуемое",
        createdAt: "Создано",
        playerId: "ID игрока",
        
        // Form placeholders
        selectPlayer: "Выберите игрока",
        selectCategory: "Выберите категорию",
        titlePlaceholder: "Введите название достижения",
        descriptionPlaceholder: "Введите описание достижения",
        pointsPlaceholder: "Введите очки (опционально)",
        
        // Player achievements
        noAchievements: "Достижения для этого игрока не найдены",
        playerAchievements: "Достижения игрока",
        achievementsTitle: "Достижения",
        
        // Categories
        categories: {
            tournament_winner: "Победитель турнира",
            best_player: "Лучший игрок",
            top_scorer: "Лучший бомбардир",
            most_assists: "Лучший ассистент",
            fair_play: "Честная игра",
            rookie_of_year: "Новичок года",
            veteran_achievement: "Ветеранское достижение",
            team_captain: "Капитан команды",
            milestone: "Веха",
            special_award: "Специальная награда"
        },
        
        // Category descriptions
        categoryDescriptions: {
            tournament_winner: "Награждается чемпионам турнира",
            best_player: "Выдающиеся индивидуальные показатели",
            top_scorer: "Лучший бомбардир соревнования",
            most_assists: "Лучший ассистент соревнования",
            fair_play: "Образцовое спортивное поведение",
            rookie_of_year: "Лучший дебютант",
            veteran_achievement: "Долгосрочный вклад в спорт",
            team_captain: "Выдающееся лидерство",
            milestone: "Карьерное достижение",
            special_award: "Специальное признание"
        },
        
        // Filters and search
        searchByTitle: "Поиск по названию...",
        allCategories: "Все категории",
        allPlayers: "Все игроки",
        allAchievements: "Все достижения",
        featuredOnly: "Только рекомендуемые",
        regularOnly: "Только обычные",
        
        // Statistics
        totalAchievements: "Всего достижений",
        featuredAchievements: "Рекомендуемые достижения",
        uniquePlayers: "Уникальные игроки",
        
        // States
        noResultsFound: "Достижения по вашему запросу не найдены",
        createFirst: "Создайте первое достижение",
        tryDifferentFilters: "Попробуйте изменить фильтры поиска",
        
        // Actions
        confirmDelete: "Удалить достижение",
        deleteWarning: "Вы уверены, что хотите удалить это достижение? Это действие нельзя отменить.",
        deleteWarningDetail: "Вы уверены, что хотите удалить '{name}'? Это действие нельзя отменить.",
        notFound: "Достижение не найдено",
        achievementNotFoundDescription: "Достижение, которое вы ищете, не существует или было удалено.",
        backToList: "Вернуться к достижениям",
        clickToViewPlayer: "Нажмите для просмотра данных игрока",
        
        // Detail page sections
        details: "Детали достижения",
        quickStats: "Быстрая статистика",
        categoryInfo: "Информация о категории",
        type: "Тип",
        regular: "Обычное",
        noPoints: "Очки не назначены",
        
        // Validation messages
        validation: {
            playerRequired: "Игрок обязателен",
            titleRequired: "Название обязательно",
            descriptionRequired: "Описание обязательно",
            dateRequired: "Дата достижения обязательна",
            categoryRequired: "Категория обязательна",
            pointsPositive: "Очки должны быть положительными или равными нулю"
        }
    },
    regions: {
        description: "Обзор регионов и распределения городов",
        totalRegions: "Всего регионов",
        totalCities: "Всего городов",
        activeCities: "Активные города",
        searchByRegion: "Поиск по региону или стране...",
        allCountries: "Все страны",
        noResultsFound: "Регионы не найдены",
        noRegions: "Регионы недоступны",
        createFirstCity: "Создайте первый город, чтобы увидеть регионы",
        cities: "Города",
        citiesList: "Список городов",
        viewCities: "Просмотр городов",
        manageCities: "Управление городами"
    },
    files: {
        title: "Управление файлами",
        description: "Загрузка и управление файлами и изображениями",
        uploadSection: "Загрузка файлов",
        displaySection: "Отображение файлов",
        selectType: "Выберите тип файла",
        objectId: "ID объекта",
        singleUpload: "Загрузка одного файла",
        multipleUpload: "Загрузка нескольких файлов",
        displayByObject: "Отображение по объекту",
        objectDisplayInfo: "Показывается {{type}} для объекта ID {{objectId}}",
        recentUploads: "Недавние загрузки",
        noFiles: "Файлы еще не загружены",
        clickToUpload: "Нажмите для загрузки",
        orDragAndDrop: "или перетащите файлы",
        upTo: "до",
        uploading: "Загрузка...",
        uploadComplete: "Загрузка завершена",
        uploadFailed: "Ошибка загрузки",
        fileTooBig: "Файл слишком большой. Максимальный размер {{maxSize}}МБ",
        invalidFileType: "Неверный тип файла. Допустимые типы: {{accept}}",
        selectFiles: "Выбрать файлы",
        selectedFiles: "Выбранные файлы",
        removeFile: "Удалить файл",
        uploadFiles: "Загрузить файлы",
        types: {
            'team-avatar': "Аватар команды",
            'user-avatar': "Аватар пользователя",
            'playground-avatar': "Аватар площадки",
            'sport-club-avatar': "Аватар спортивного клуба",
            'sport-club-hero': "Главное изображение клуба",
            'tournament-logo': "Логотип турнира",
            'player-avatar': "Аватар игрока",
            'match-photo': "Фото матча",
            'achievement-icon': "Иконка достижения",
            'general': "Общий файл"
        },
        error: {
            fileTooBig: "Файл слишком большой. Максимальный размер {{maxSize}}МБ",
            invalidFileType: "Неверный тип файла. Допустимые типы: {{accept}}",
            uploadFailed: "Ошибка загрузки. Попробуйте снова.",
            loadFailed: "Не удалось загрузить изображение"
        }
    },
    tournamentCategories: {
        title: "Категории турниров",
        description: "Управление категориями турниров",
        name: "Название категории",
        categoryInformation: "Информация о категории",
        categoryDetails: "Детали и информация о категории",
        categoryId: "ID категории",
        create: "Создать категорию",
        edit: "Редактировать категорию",
        list: "Список категорий",
        total: "Всего категорий",
        noCategories: "Категории не найдены",
        createFirst: "Создайте вашу первую категорию",
        searchName: "Поиск по названию...",
        namePlaceholder: "Введите название категории",
        descriptionPlaceholder: "Введите описание категории",
        backToList: "Назад к категориям",
        notFound: "Категория не найдена",
        notFoundDescription: "Категория, которую вы ищете, не существует или была удалена.",
        deleteConfirmation: "Вы уверены, что хотите удалить категорию '{name}'? Это действие нельзя отменить.",
        selectCategory: "Выберите категорию",
        allCategories: "Все категории",
        unknownCategory: "Неизвестная категория",
        validation: {
            nameRequired: "Название категории обязательно",
            nameMinLength: "Название категории должно содержать минимум 2 символа",
            nameMaxLength: "Название категории не должно превышать 100 символов",
            descriptionRequired: "Описание обязательно",
            descriptionMinLength: "Описание должно содержать минимум 5 символов",
            descriptionMaxLength: "Описание не должно превышать 500 символов"
        }
    },
    users: {
        title: "Пользователи",
        subtitle: "Управление пользователями системы и их ролями",
        createUser: "Создать пользователя",
        editUser: "Редактировать пользователя",
        userDetails: "Детали пользователя",
        noUsers: "Пользователи не найдены",
        noUsersFound: "Пользователи не найдены",
        searchHint: "Поиск по имени, фамилии или телефону...",
        createFirst: "Создайте первого пользователя",
        basicInfo: "Основная информация",
        firstname: "Имя",
        lastname: "Фамилия",
        phone: "Телефон",
        password: "Пароль",
        passwordOptional: "Оставьте пустым для сохранения текущего пароля",
        passwordHint: "Оставьте пустым для сохранения текущего пароля",
        roles: "Роли",
        manageRoles: "Управление ролями",
        name: "Имя",
        userId: "ID пользователя",
        totalRoles: "Всего ролей",
        userStatus: "Статус",
        noRoles: "Роли не назначены",
        confirmDelete: "Подтвердить удаление",
        deleteWarning: "Вы уверены, что хотите удалить пользователя {name}? Это действие нельзя отменить.",
        deleteWarningDetail: "Вы уверены, что хотите удалить пользователя {name}? Это действие нельзя отменить и удалит все связанные данные.",
        notFound: "Пользователь не найден",
        firstnamePlaceholder: "Введите имя",
        lastnamePlaceholder: "Введите фамилию",
        phonePlaceholder: "Введите номер телефона",
        passwordPlaceholder: "Введите пароль",
        searchByFirstname: "Поиск по имени...",
        searchByLastname: "Поиск по фамилии...",
        searchByPhone: "Поиск по телефону...",
        sortBy: "Сортировать по",
        sortDirection: "Направление сортировки",
        ascending: "По возрастанию",
        descending: "По убыванию",
        validation: {
            selectRole: "Должна быть выбрана хотя бы одна роль"
        }
    },
    debug: {
        performanceMonitor: "Монитор производительности",
        totalRenders: "Всего рендеров",
        avgTime: "Среднее время",
        slowestComponent: "Самый медленный компонент",
        recentRenders: "Последние рендеры",
        clear: "Очистить",
        export: "Экспорт"
    },
    sportClubs: {
        title: "Спортивные секции",
        subtitle: "Управление спортивными секциями и клубами",
        sportClub: "Спортивная секция",
        createSportClub: "Создать спортивная секция",
        editSportClub: "Редактировать спортивная секция",
        noSportClubs: "Спортивные секции не найдены",
        createFirst: "Создайте вашу первую спортивную секцию",
        searchPlaceholder: "Поиск по названию секции...",
        basicInfo: "Основная информация",
        name: "Название секции",
        namePlaceholder: "Введите название спортивной секции",
        description: "Описание",
        descriptionPlaceholder: "Введите описание секции",
        clubType: "Тип клуба",
        sportType: "Вид спорта",
        ageRange: "Возрастной диапазон",
        minAge: "Минимальный возраст",
        maxAge: "Максимальный возраст",
        establishmentYear: "Год основания",
        established: "Основано в",
        membershipFee: "Членский взнос",
        clubTypes: {
            kids: "Детский",
            regular: "Обычный",
            professional: "Профессиональный",
            mixed: "Смешанный"
        },
        contactInfo: "Контактная информация",
        contactEmail: "Email",
        contactPhone: "Телефон",
        website: "Веб-сайт",
        addresses: "Адреса",
        address: "Адрес",
        addAddress: "Добавить адрес",
        streetLine1: "Адрес (строка 1)",
        streetLine1Placeholder: "Введите основной адрес",
        streetLine2: "Адрес (строка 2)",
        streetLine2Placeholder: "Дополнительная информация об адресе",
        zipCode: "Почтовый индекс",
        addressDescription: "Описание адреса",
        addressDescriptionPlaceholder: "Описание расположения (например, 'главный вход')",
        primary: "Основной",
        setPrimary: "Сделать основным",
        location: "Местоположение",
        coordinates: "Координаты",
        selectOnMap: "Выбрать на карте",
        openingHours: "Часы работы",
        addOpeningHours: "Добавить часы работы",
        day: "День",
        dayOfWeek: "День недели",
        openTime: "Время открытия",
        closeTime: "Время закрытия",
        closed: "Закрыто",
        ageCategories: "Возрастные категории",
        ageCategoriesHint: "Вы можете добавить несколько возрастных групп (U6, U8, U10 и т.д.) в одну секцию",
        addAgeCategory: "Добавить возрастную категорию",
        ageCategory: "Возрастная категория",
        ageCategoryType: "Тип возрастной категории",
        maxParticipants: "Макс. участников",
        currentParticipants: "Текущие участники",
        categoryDescription: "Описание категории",
        categoryDescriptionPlaceholder: "Описание для этой возрастной категории",
        categoryActive: "Активна",
        additionalInfo: "Дополнительная информация",
        facilities: "Удобства и оборудование",
        facilitiesPlaceholder: "Опишите доступные удобства и спортивное оборудование",
        membershipBenefits: "Преимущества членства",
        membershipBenefitsPlaceholder: "Опишите преимущества и льготы для членов секции",
        operatingHours: "Часы работы",
        operatingHoursPlaceholder: "Например: Пн-Пт 9:00-21:00, Сб-Вс 10:00-18:00",
        active: "Активен",
        teams: "Команды",
        selectTeams: "Выбрать команды",
        nameRequired: "Название секции обязательно",
        sportTypeRequired: "Вид спорта обязателен",
        minAgeInvalid: "Минимальный возраст должен быть больше 0",
        maxAgeInvalid: "Максимальный возраст должен быть больше минимального",
        addressRequired: "Необходимо указать хотя бы один адрес",
        streetRequired: "Адрес (строка 1) обязателен",
        cityRequired: "Город обязателен",
        emailInvalid: "Неверный формат email",
        confirmDelete: "Удалить спортивную секцию",
        deleteWarning: "Вы уверены, что хотите удалить эту спортивную секцию? Это действие нельзя отменить.",
        deleteWarningDetail: "Вы уверены, что хотите удалить секцию '{name}'? Это действие нельзя отменить.",
        notFound: "Спортивная секция не найдена",
        years: "лет",
        activeFilters: "Активные фильтры",
        goBack: "Вернуться",
        heroId: "ID главного изображения",
        heroGif: "Главная GIF",
        uploadAvatar: "Загрузить аватар клуба",
        uploadHero: "Загрузить главное изображение",
        avatarUploaded: "Аватар клуба успешно загружен",
        heroUploaded: "Главное изображение успешно загружено",
        clubAvatar: "Аватар клуба",
        heroImage: "Главное изображение",
        clubImages: "Изображения клуба"
    },
    reservations: {
        title: "Резервации",
        subtitle: "Управление резервациями площадок",
        noReservations: "Резервации не найдены",
        confirmDelete: "Вы уверены, что хотите удалить эту резервацию?",
        form: {
            startTime: "Время начала",
            endTime: "Время окончания",
            submit: "Создать резервацию"
        },
        validation: {
            startTimeRequired: "Время начала обязательно",
            endTimeRequired: "Время окончания обязательно",
            endTimeAfterStart: "Время окончания должно быть после времени начала",
            startTimeInFuture: "Время начала должно быть в будущем"
        },
        status: {
            current: "Текущий статус",
            change: "Изменить статус",
            updating: "Обновление статуса...",
            pending: "Ожидание",
            confirmed: "Подтверждено",
            cancelled: "Отменено",
            completed: "Завершено",
            paid: "Оплачено"
        },
        payment: {
            title: "Оплата",
            form: {
                method: "Способ оплаты",
                amount: "Сумма",
                submit: "Обработать платёж"
            },
            validation: {
                methodRequired: "Способ оплаты обязателен",
                amountRequired: "Сумма должна быть больше 0"
            },
            methods: {
                cash: "Наличные",
                card: "Карта",
                bank_transfer: "Банковский перевод",
                online: "Онлайн"
            }
        },
        details: {
            id: "ID резервации",
            startTime: "Время начала",
            endTime: "Время окончания",
            userId: "ID пользователя",
            price: "Цена"
        },
        actions: {
            pay: "Оплатить",
            delete: "Удалить"
        },
        filters: {
            userIdPlaceholder: "Введите ID пользователя",
            startDate: "Дата начала",
            endDate: "Дата окончания"
        }
    },
    mobile: {
        tournamentMatchesTitle: "Матчи турнира",
        roundLabel: "Тур",
        loadingTournament: "Загрузка турнира...",
        tournamentUnavailable: "Турнир недоступен",
        team1: "Команда 1",
        team2: "Команда 2",
        playgroundTBD: "Площадка уточняется",
        loadingTable: "Загрузка таблицы...",
        noTableData: "Данные таблицы пока отсутствуют",
        today: "СЕГОДНЯ",
        daysShort: {
            monday: "ПН",
            tuesday: "ВТ",
            wednesday: "СР",
            thursday: "ЧТ",
            friday: "ПТ",
            saturday: "СБ",
            sunday: "ВС"
        }
    },
    favorites: {
        title: "Избранное",
        subtitle: "Управление избранными элементами",
        noFavorites: "Избранное пусто",
        noFavoritesSubtext: "Элементы, добавленные в избранное, появятся здесь",
        addedOn: "Добавлено",
        entityTypes: {
            team: "Команды",
            tournament: "Турниры",
            playground: "Площадки",
            match: "Матчи",
            player: "Игроки",
            sportClub: "Спортивные секции"
        },
        search: {
            placeholder: "Поиск в избранном",
            byId: "Поиск по ID..."
        },
        actions: {
            addToFavorites: "Добавить в избранное",
            removeFromFavorites: "Удалить из избранного",
            favorited: "В избранном"
        },
        messages: {
            addedToFavorites: "Добавлено в избранное",
            removedFromFavorites: "Удалено из избранного",
            errorAdding: "Ошибка добавления в избранное",
            errorRemoving: "Ошибка удаления из избранного"
        }
    }
};
